import React from 'react'
export function ManageLSPCarrierPage() {
    return (
        <ManageLSPCarrierPage/>
    )
}
